// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	requireSSO: true,

	//PETRONAS SSO Configs
	SSO_CONFIG: {
		CLIENT_ID: '766c2f8d-7683-4b0d-80e9-dab07cc7d2e9',
		TENANT_ID: '8b24551d-7c2c-4beb-8b61-95f32d9929ef',
		AUTHORITY: 'https://login.microsoftonline.com/',
		REDIRECT_URL: 'https://webconsole.dev.upx.petronas.com/home',
		POST_LOGOUT_REDIRECT_URI: 'https://webconsole.dev.upx.petronas.com',
		MS_GRAPH_API: 'https://graph.microsoft.com/v1.0/me',
	},

	//Micro-Service Configs
	MS_CONFIG: {
		URL: 'https://dev.upx.petronas.com/api/gate',
	},

	//Log Configs
	LOG_CONFIGS: {
		enableLogs: true,
		enableInfoLogs: true,
		enableErrorLogs: true,
	},

	//Error Types Config
	ERROR_TYPE: {
		UNAUTHORIZED: 'unauthorized',
		FORBIDDEN: 'forbidden',
		NOTFOUND: 'notfound',
		SERVERERROR: 'servererror',
		TIMEOUT: 'timeout',
		OTHER: 'other',
	},
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
